import React, { Suspense } from "react";
import { useNavigate } from "react-router-dom";

const NavBar = React.lazy(() => import("../../components/navBar"));
const Footer = React.lazy(() => import("../../components/footer"));

const ContactUs = () => {
  const navigate = useNavigate();
  return (
    <>
      <Suspense fallback={<div className="loader"></div>}>
        <NavBar push={navigate} />
        <div className="container" style={{ height: "50vh" }}></div>
        <Footer />
      </Suspense>
    </>
  );
};

export default ContactUs;
